(function () {
    "use strict";

    angular.module("app").component("pscisScopeLevelsView", {
        templateUrl: "@/pscis/pscis-scope-levels-view.template.html",
        controller: ViewController,
        controllerAs: "vm",
        bindings: {
            allowedLevels: "<",
            scopeLevels: "=",
            codeTypes: "<",
        }
    });

    ViewController.$inject = [];
    function ViewController() {
        const vm = this;

        // Lifecycle hook to initialize logic if needed
        vm.$onInit = function () {
            // Ensure request objects exist to prevent errors on render
            if (!vm.scopeLevels) {
                vm.scopeLevels = [];
            }
        };

        vm.hasScopeLevel = function (scope, level) {
            if (!vm.scopeLevels)
                return false;

            return vm.scopeLevels.some(function (item) {
                return item.Scope === scope && item.Level === level;
            });
        };
    }
})();